import { createSignal, onMount } from 'solid-js'
import { res2json } from '@/utils'

export default function Login() {
  const [step, setStep] = createSignal('login')
  const [secret, setSecret] = createSignal('')
  const [secretUri, setSecretUri] = createSignal('')

  function next(val) {
    setSecret(val.secret)
    setSecretUri(val.uri)
    // setStep('otp')
  }

  return (
    <div class="fixed inset-0 flex items-center justify-center">
      {step() === 'login' && (<LoginForm onNext={next} />)}
      {/* {step() === 'otp' && (<OtpForm secret={secret()} uri={secretUri()} />)} */}
    </div>
  )
}

function LoginForm({ onNext }) {
  const [username, setUsername] = createSignal('')
  const [password, setPassword] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  let elFocus
  onMount(() => {
    elFocus.focus()
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: username(),
        password: password()
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        // onNext(r.data)
        document.location.reload()
      }
    }).finally(() => { setSending(false) })
  }

  return (
    <form onSubmit={submit} class="flex flex-col gap-6 max-w-96 px-4 lg:px-0">
      <h1 class="text-2xl">登陆总代后台</h1>
      <div class="form-control">
        <div class="label"><span class="label-text">用户名</span></div>
        <input ref={elFocus} type="text" value={username()} onChange={e => setUsername(e.target.value)} class="input input-bordered" placeholder="请输入您的用户名" required />
        {errors().username && (<div class="label"><span class="label-text-alt text-error">{errors().username}</span></div>)}
      </div>
      <div class="form-control">
        <div class="label"><span class="label-text">登陆密码</span></div>
        <input type="password" onChange={e => setPassword(e.target.value)} class="input input-bordered" placeholder="请输入登陆密码" required />
        {errors().password && (<div class="label"><span class="label-text-alt text-error">{errors().password}</span></div>)}
      </div>
      {errors().default && (<div class="text-error">{errors().default}</div>)}
      <div class="form-control">
        <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>提交登陆</button>
      </div>
    </form>
  )
}

function OtpForm({ secret, uri }) {
  const [otp, setOtp] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  let elFocus, elQrcode
  onMount(() => {
    elFocus.focus()
    if (secret && uri) {
      elQrcode.innerHTML = ''
      new window.QRCode(elQrcode, { text: uri, width: 256, height: 256, correctLevel: window.QRCode.CorrectLevel.H })
    }
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch('/api/login-otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        otp: otp()
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        document.location.reload()
      }
    }).finally(() => { setSending(false) })
  }

  return (
    <form onSubmit={submit} class="flex flex-col gap-6 max-w-96 px-4 lg:px-0">
      <h1 class="text-2xl">登陆总代后台</h1>
      <div class="form-control">
        <div class="label"><span class="label-text">OTP</span></div>
        <input ref={elFocus} type="number" value={otp()} onChange={e => setOtp(e.target.value)} class="input input-bordered no-spin" placeholder="请输入 OTP" required />
        {errors().otp && (<div class="label"><span class="label-text-alt text-error">{errors().otp}</span></div>)}
      </div>
      {secret && (
        <div class="flex flex-col items-center gap-4">
          <div>请使用 Google Authenticator 或其它类似工具扫描下面的二维码，并在上面输入 OTP 代码。下次登陆时不会再显示下面的二维码</div>
          <div ref={elQrcode}></div>
          <div>{secret}</div>
        </div>
      )}
      <div class="form-control">
        <button type="submit" class="btn btn-success text-white w-full" disabled={sending()}>提交登陆</button>
      </div>
    </form>
  )
}
